<template>
    <vs-popup title="Ajouter une question" :active.sync="isPromptActiveLocal">
        <vs-row style="margin-bottom:10px">
            <vs-col vs-type="flex" vs-w="12">
                <input type="file" id="file" ref="file"
                       accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                       v-on:change="handleFileUpload()"/>
            </vs-col>
            <span style="color: red" v-if="error_data.file">{{ error_data.file ? error_data.file[0] : '' }}</span>
        </vs-row>
        <br>
        <vs-button :disabled="!isEnable" @click="add()" color="primary" type="filled">Enregistrer</vs-button>
    </vs-popup>
</template>

<script>
    const default_form = {
        file: ''
    }
    export default {
        name: "importQuestion",
        props: {
            isPromptActive: {
                type: Boolean,
                required: true
            },
            loadQuestionnaireByEvaluation:{
                type: Function
            }
        },
        data: () => ({
            error_data: [],
            form: {
                file: ''
            }
        }),
        methods: {
            handleFileUpload(){
                this.form.file = this.$refs.file.files[0];
            },
            add() {
                if (this.form.file){
                    this.$vs.loading()
                    let formData = new FormData()
                    formData.append('file', this.form.file)
                    formData.append('evaluation_id', this.$route.params.id)
                    this.$http.post('questionnaires/create/bulk', formData).then(() => {
                        window.getApp.success("Question ajouté", {})
                        this.$vs.loading.close()
                        this.form = {...default_form}
                        this.error_data = []
                        this.$emit('closeFile')
                        this.loadQuestionnaireByEvaluation()
                    }).catch((error) => {
                        this.$vs.loading.close()
                        this.error_data = error.response.data.errors
                    })
                }
            }
        },
        watch: {
            isPromptActive(val) {
                if (!val) return;
            },
        },
        computed: {
            isEnable(){
                return !!this.form.file;
            },
            isPromptActiveLocal: {
                get() {
                    return this.isPromptActive
                },
                set(val) {
                    if (!val) {
                        this.error_data = []
                        this.form.file = ''
                        this.$emit('closeFile')
                    }
                }
            },
        },
    }
</script>

<style scoped>

</style>
